Tooltip = require 'components/common/tooltip'

Button = createReactClass
  displayName: 'Button'

  propTypes:
    className: PropTypes.string
    label: PropTypes.string
    shape: PropTypes.oneOf ['default', 'pill', 'narrow-pill']
    icon: PropTypes.string

  getDefaultProps: ->
    shape: 'default'
    className: ''
    label: ''
    icon: null

  render: ->
    { shape, label, className, icon } = @props
    classes = classNames className, icon,
      'btn-pill': shape is 'pill'
      'btn-narrow-pill': shape is 'narrow-pill'
      'icon': icon

    restProps = _(@props).omit 'shape', 'label', 'className', 'icon'

    <Tooltip>
      <button {...restProps} className={classes}>
        {label}
      </button>
    </Tooltip>

module.exports = Button
